import { type PartialPropsOf } from '@blaze-runtime/engine-domain';

import { type PropsMigration } from '../../../services/compat/migrations/layout-migration.models';

export const avatarV2PaddingToMarginMigration: PropsMigration = {
  mode: 'props',
  description: 'Migrate avatar external spacing from offset.padding to offset.margin',
  run: (props: PartialPropsOf<'avatar'>): void => {
    const offset = props.style?.general?.offset;
    if (offset?.padding === undefined) {
      return;
    }
    offset.margin = offset.padding;
    delete offset.padding;
  },
};
